// extracted by mini-css-extract-plugin
export default {"drawer":"MatchingFacets_drawer__GxSS3"};